export const containerStyles = (expanded: boolean) => ({
  border: "none",
  backgroundColor: expanded ? "#FF5995" : "",
  display: "flex",
  height: expanded ? "2.75rem" : "1.75rem",
  width: expanded ? "2.75rem" : "1.75rem",
  fontSize: expanded ? "1.125rem" : "1.75rem",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  color: "white",
  cursor: "pointer",
  outline: "0px"
});
